{
  "status": {
    "pending": "待出報告",
    "preliminary": "初步報告",
    "final": "最終報告",
    "corrected": "更正報告",
    "amended": "補充報告",
    "addended": "已有補充",
    "enteredInError": "輸入錯誤",
    "unknown": "未知"
  },
  "review": {
    "title": "結果審閱",
    "printLabel": "列印結果",
    "summary": {
      "count_one": "{{count}} 筆結果",
      "count_other": "{{count}} 筆結果",
      "criticalUnacknowledged": "{{count}} 筆危急值未確認"
    },
    "view": {
      "timeline": "時間軸",
      "flowsheet": "流水表"
    },
    "filter": {
      "date": "日期",
      "type": "類型",
      "status": "狀態",
      "statusAll": "全部"
    },
    "dateRange": {
      "h24": "近 24 小時",
      "h48": "近 48 小時",
      "d7": "近 7 天",
      "d30": "近 30 天",
      "all": "全部"
    },
    "resultType": {
      "all": "全部",
      "lab": "檢驗",
      "imaging": "影像",
      "pathology": "病理",
      "cardiology": "心電",
      "microbiology": "微生物"
    },
    "criticalOnlyToggle": "僅顯示危急值",
    "criticalBadge": "危急",
    "actions": {
      "acknowledgeCritical": "確認危急值",
      "acknowledgeAllCritical": "確認全部危急結果 ({{count}})"
    },
    "detail": {
      "resultNumber": "結果編號",
      "performingProviderId": "執行醫師編號",
      "verifiedByProviderId": "審核醫師編號",
      "verifiedAt": "審核時間",
      "specimenCollected": "檢體採集時間",
      "clinicalSignificance": "臨床意義",
      "recommendations": "建議",
      "report": "報告",
      "addendum": "補充報告",
      "criticalAcknowledged": "危急值已確認",
      "providerHash": "醫師 #{{id}}",
      "acknowledgedAt": " 時間 {{when}}",
      "specimenType": "標本類型",
      "grossDescription": "大體描述",
      "microscopicDescription": "鏡下描述",
      "accessionNumber": "檢查號",
      "bodyRegion": "檢查部位",
      "studyInstanceUid": "檢查實例 UID",
      "cardiologyMeasurements": "測量值",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "正在載入結果…",
    "loadError": "載入結果失敗,請再試一次。",
    "empty": "找不到符合所選篩選條件的結果。",
    "toast": {
      "acknowledgeSuccess": "危急值已確認",
      "acknowledgeError": "確認結果失敗"
    },
    "susceptibility": {
      "title": "病原體與藥敏",
      "antibiotic": "抗菌藥物",
      "interpretation": "判讀",
      "mic": "MIC",
      "unnamedOrganism": "未命名病原體",
      "noPanel": "該病原體未報告藥敏結果。"
    },
    "components": {
      "value": "結果值",
      "referenceRange": "參考範圍"
    }
  },
  "pending": {
    "title": "待出結果",
    "countBadge_one": "{{count}} 筆待出",
    "countBadge_other": "{{count}} 筆待出",
    "autoRefresh": "自動更新 {{seconds}} 秒",
    "updated": "更新於 {{when}}",
    "searchPlaceholder": "依病人姓名、MRN 或醫囑搜尋…",
    "filtersButton": "篩選",
    "fields": {
      "orderType": "醫囑類型",
      "allTypes": "全部類型",
      "priority": "優先順序",
      "allPriorities": "全部優先順序",
      "dateFrom": "起始日期",
      "dateTo": "截止日期"
    },
    "orderType": {
      "lab": "檢驗",
      "imaging": "影像",
      "procedure": "處置",
      "consultation": "會診",
      "laboratory": "檢驗",
      "radiology": "放射",
      "surgery": "手術",
      "therapy": "治療",
      "medication": "用藥",
      "admission": "入院"
    },
    "aria": {
      "dateFrom": "待出結果起始日期",
      "dateTo": "待出結果截止日期"
    },
    "columns": {
      "patient": "病人",
      "mrn": "MRN",
      "order": "醫囑",
      "type": "類型",
      "orderedBy": "開立醫師",
      "ordered": "開立時間",
      "expected": "預計時間",
      "priority": "優先順序"
    },
    "loading": "正在載入待出結果…",
    "loadError": "載入待出結果失敗",
    "retry": "重試",
    "empty": "找不到待出結果。",
    "awaitingResult": "等候結果",
    "specimenReceived": "檢體已收件",
    "inLab": "檢驗中",
    "cancelledByLab": "檢驗室已取消",
    "overdue": "已逾時",
    "expectedBy": "預計 {{date}} 前出"
  },
  "critical": {
    "title": "危急值結果",
    "autoRefresh": "自動更新 {{seconds}} 秒",
    "updated": "更新於 {{when}}",
    "unacknowledgedHeading_one": "{{count}} 筆危急值未確認",
    "unacknowledgedHeading_other": "{{count}} 筆危急值未確認",
    "escalationBanner": "上述結果需醫師立即確認。",
    "acknowledgeWithinMinutes": "請於 {{minutes}} 分鐘內確認",
    "routeBackToProvider": "轉回開立醫師",
    "attendingSignoff": "需主治醫師簽核",
    "searchPlaceholder": "依病人或檢查名稱搜尋…",
    "showAcknowledgedToggle": "顯示已確認",
    "escalationTime": "T+{{minutes}} 分",
    "criticalFallback": "危急",
    "loading": "正在載入危急值結果…",
    "loadError": "載入危急值結果失敗",
    "empty": "無待確認的危急值結果。",
    "detailToggleLabel": "顯示結果詳情",
    "openFullChart": "開啟完整病歷",
    "columns": {
      "patient": "病人",
      "mrn": "MRN",
      "test": "檢查項目",
      "value": "數值",
      "impression": "印象",
      "resultTime": "結果時間",
      "escalation": "升級時長",
      "acknowledged": "已確認",
      "actions": "操作"
    },
    "actions": {
      "acknowledge": "確認"
    },
    "toast": {
      "acknowledgeSuccess": "危急值已確認",
      "acknowledgeError": "確認結果失敗"
    },
    "refreshFailed": "無法重新整理——顯示的是{{when}}的危急值結果。",
    "incomplete": "僅顯示 {{total}} 項危急值結果中的 {{shown}} 項。此清單不完整。"
  },
  "acknowledged": {
    "pending": "等候確認",
    "acknowledged": "已確認",
    "escalated": "已升級",
    "expired": "確認時限已過"
  },
  "flowsheet": {
    "analyte": "檢驗項目",
    "empty": "暫無可趨勢分析的檢驗項目",
    "emptyHint": "影像、病理與微生物報告顯示在時間軸檢視中。",
    "trend": {
      "toggle": "{{analyte}} 趨勢圖",
      "referenceRange": "參考值 {{range}}",
      "nonNumericOmitted_one": "{{count}} 項文字結果未繪製",
      "nonNumericOmitted_other": "{{count}} 項文字結果未繪製"
    }
  }
}
